import {
  historicalAvailabilityView,
  historicalAvailabilityDataLoadLookerDashboard,
  historicalAvailabilityDataLoadLookerDashboardError,
} from 'core/telemetry/avo/Avo';

export const telemetryHistoricalVenueAvailabilityView = () => {
  historicalAvailabilityView({
    durationMs: 0,
  });
};

export const telemetryLoadLookerDashboardDuration = (durationMs: number) => {
  historicalAvailabilityDataLoadLookerDashboard({
    durationMs,
  });
};

export const telemetryLoadLookerDashboardError = () => {
  historicalAvailabilityDataLoadLookerDashboardError();
};
